import { Select } from 'antd';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import { ICommonInputProps } from './types';

const { Option } = Select;

const SelectStyled = styled(Select)<{ allowClear?: boolean; value?: any }>`
  width: 100%;
  & .ant-select-selector {
    width: 100%;
  }
  .ant-select-arrow {
    ${({ allowClear, value }) => (allowClear && value !== undefined ? 'display: none' : '')}
  }

  .ant-select-clear {
    top: 0;
    margin-top: 0;
    height: 100%;
    background: transparent;
    width: 20px;
    opacity: 1;
    display: ${({ allowClear, value }) => (allowClear && value !== undefined ? 'block' : 'none')};
    > .anticon-close-circle {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

const SelectInput: React.FC<ICommonInputProps> = ({
  disabled,
  placeholder,
  defaultValue,
  inputSettings,
  inputOptions,
  inputClassName,
  onChange,
  onBlur,
  value,
}) => {
  const generateSelectOptions = useCallback(
    (opt, index: number) => (
      <Option key={opt.value !== undefined ? opt.value : index} value={opt.value} disabled={opt.disabled}>
        {opt.label}
      </Option>
    ),
    [value],
  );

  return (
    <SelectStyled
      disabled={disabled}
      placeholder={placeholder || 'Select...'}
      defaultValue={defaultValue === undefined ? undefined : defaultValue}
      value={value === undefined ? undefined : value}
      mode={inputSettings?.mode}
      filterOption={(input, option) =>
        option?.props.children.toLowerCase().includes(input.toLowerCase()) ||
        option?.props.value.toLowerCase().includes(input.toLowerCase())
      }
      showSearch={inputSettings?.showSearch}
      onBlur={onBlur}
      showArrow
      allowClear={inputSettings?.allowClear}
      className={`select-input ${inputClassName}`}
      dropdownRender={(menu) => <div onScroll={inputSettings?.onSelectDropdownScroll}>{menu}</div>}
      onChange={onChange}>
      {inputOptions && inputOptions.map(generateSelectOptions)}
    </SelectStyled>
  );
};

export default React.memo(SelectInput);
